import { createSelector } from "reselect";
import { RootState } from "../reducers";

export const selectUsers = (state: RootState) => state.users.users;

export const selectUsersLoading = (state: RootState) => state.users.isLoading;

export const selectUsersNavLoading = (state: RootState) =>
  state.users.navLoading;

export const selectUsersPage = (state: RootState) => state.users.page;

export const selectUsersFilteredTotal = (state: RootState) =>
  state.users.filteredTotal;

export const selectUsersFilteredCount = createSelector(
  selectUsers,
  users => users.length,
);
export const selectUsersMeta = (state: RootState) => state.users.meta;

export const selectUsersRecordCount = createSelector(
  selectUsersMeta,
  meta => meta.recordCount,
);

export const selectUsersPageCount = createSelector(
  selectUsersMeta,
  meta => meta.pageCount,
);
